import { render, staticRenderFns } from "./KnowledgeEditIndex.vue?vue&type=template&id=0cc26f3a&scoped=true"
import script from "./KnowledgeEditIndex.vue?vue&type=script&lang=js"
export * from "./KnowledgeEditIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc26f3a",
  null
  
)

export default component.exports